/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const BinaryFileR = t.interface({});

// optional attributes
const BinaryFileO = t.partial({
  fileContent: t.readonlyArray(t.string, "array of string"),

  fileHash: t.readonlyArray(t.string, "array of string"),

  fileSize: t.Integer,

  id: t.Integer,

  signatureType: t.string,

  xmlFileContent: t.string
});

export const BinaryFile = t.intersection(
  [BinaryFileR, BinaryFileO],
  "BinaryFile"
);

export type BinaryFile = t.TypeOf<typeof BinaryFile>;
